import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import Buefy from 'buefy';
import lodash from 'lodash';
import 'buefy/dist/buefy.min.css';
import App from './App.vue';
import router from './router';
import './assets/sass/main.sass';

Object.defineProperty(Vue.prototype, '$lodash', {
  value: lodash,
});

Vue.use(VueAnalytics, {
  id: 'UA-135638844-1',
  router,
});
Vue.use(Buefy);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
